import type { ReactNode } from 'react';
import { Modal } from '../../Modal';

// Rediseño · Bloque C. El diálogo del rediseño: una hoja que sube desde el pie en teléfono y una
// tarjeta centrada en una ventana ancha (las hojas de P-021 y el modal de P-030).
//
// No es un diálogo nuevo: es `Modal` —la base de overlays que el Bloque A endureció— con otra piel.
// El foco entra al abrir y vuelve a quien abrió, Tab da la vuelta dentro, Escape y el Atrás de
// Android cierran solo el de arriba, y mientras está ocupado no se cierra. Aquí no se repite nada de
// eso: cualquier corrección de esa base llega también a este.
export interface DialogProps {
  title: string;
  /** Una línea bajo el título. Se anuncia junto con él. */
  description?: string;
  children: ReactNode;
  /** Los botones del pie. En teléfono se reparten el ancho. */
  footer?: ReactNode;
  /** Mientras es `true` no se puede cerrar: ni la «×», ni el fondo, ni Escape, ni el Atrás. */
  isBusy?: boolean;
  onClose: () => void;
}

export function Dialog({ title, description, children, footer, isBusy = false, onClose }: DialogProps) {
  return (
    <Modal description={description} footer={footer} isBusy={isBusy} onClose={onClose} skin="n3" title={title}>
      {children}
    </Modal>
  );
}
